import base from "./base";
import admin from "./admin";
import blog from "./blog";

export const api = {
  base,
  admin,
  blog,
};
